export const isValidEnumValue = <T extends { [k: string]: string }>(
	enumObject: T,
	value: any // eslint-disable-line @typescript-eslint/no-explicit-any
): value is T[keyof T] => Object.values(enumObject).includes(value);
